import {
  Component,
  EventEmitter,
  Input,
  Output,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PanelModule } from 'primeng/panel';
import { LanguageKey } from 'src/main/translate/language-key/language-key';
import { TranslateKeyPipe } from '../../../pipes/translate-key/translate-key.pipe';
import { FormatTranslatePipe } from '../../../pipes/format-translate.pipe';

export interface GenericOption {
  id: string | number | undefined;
  name: string | undefined;
  color: string | undefined;
  checked: boolean | undefined;
  [key: string]: any;
}

@Component({
  selector: 'app-button-selector',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SelectButtonModule,
    PanelModule,
    TranslateKeyPipe,
    FormatTranslatePipe,
  ],
  templateUrl: './button-selector.component.html',
  styleUrls: ['./button-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonSelectorComponent {
  public languageKey = LanguageKey;
  private _options: GenericOption[] = [];
  @Input() title: string;
  @Input() registerType: string;
  @Input() multiple = true;

  @Input()
  set options(value: GenericOption[]) {
    this._options = value || [];
  }

  get options(): GenericOption[] {
    return this._options;
  }

  @Input() set initialData(data: GenericOption[]) {
    if (data) {
      this.selectedItems.set(data);
    }
  }

  @Output() selectionChange = new EventEmitter<GenericOption[]>();

  public selectedItems = signal<GenericOption[]>([]);

  modelValue(): GenericOption[] | GenericOption | undefined {
    const selected = this.selectedItems();
    return this.multiple ? selected : selected[0];
  }

  isItemSelected(item: GenericOption): boolean {
    return this.selectedItems().some((selected) => selected.id === item.id);
  }

  onSelectChange(event: any) {
    const value = event?.value;
    const normalizedValue = Array.isArray(value) ? value : value ? [value] : [];

    this.selectedItems.set(normalizedValue);
    this.selectionChange.emit(normalizedValue);
  }
}
